<template>
  <div class="flex items-center gap-3">
    <NButton
      variant="flat"
      color="gray"
      class="flex-1"
      size="small"
      @click="remove()"
    >
      <NText variant="caption1" weight="bold">
        {{ t('common.refuse') }}
      </NText>
    </NButton>

    <NButton
      variant="fill"
      color="red"
      class="flex-1"
      size="small"
      @click="handleDeleteOffer"
    >
      <NText variant="caption1" weight="bold">
        {{ t('common.cancelRequest') }}
      </NText>
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog, useToast } from '@negar/core';
import {
  useDeletePreInitialPublicOffer,
  useDeleteInitialPublicOffer,
  IPO_ORDER_TYPE,
  IPO_QUERY_KEYS,
} from '@core/ipo';
import { InitialPublicOfferItem } from '@libs/api-reference';
import { useQueryClient } from '@libs/use';

const props = defineProps<{
  isin: string;
  orderId: string | undefined;
  orderType: string;
  offer: InitialPublicOfferItem;
}>();

const { t } = useI18n();
const toast = useToast();
const queryClient = useQueryClient();

const { remove, removeAll } = useDialog();

const { deletePreInitialOffer } = useDeletePreInitialPublicOffer({
  onSuccess() {
    toast.neutral({
      message: t('ipo.preOrderDelete', {
        symbol: props.offer.instrumentTitle,
      }),
      duration: 3000,
    });

    queryClient.invalidateQueries(IPO_QUERY_KEYS.ipo);

    removeAll();
  },

  onReject(error) {
    for (const { message } of error.response.data) {
      toast.negative({
        message,
        duration: 3000,
      });
    }
  },
});

const { deleteInitialOffer } = useDeleteInitialPublicOffer({
  onSuccess() {
    toast.neutral({
      message: t('ipo.preOrderDelete', {
        symbol: props.offer.instrumentTitle,
      }),
      duration: 3000,
    });

    queryClient.invalidateQueries(IPO_QUERY_KEYS.ipo);

    removeAll();
  },

  onReject(error) {
    const message = error.response?.data[0].message;

    if (message) {
      toast.negative({
        message,
        duration: 3000,
      });
    }
  },
});

const handleDeleteOffer = () => {
  if (
    props.orderType === IPO_ORDER_TYPE.preOrder ||
    props.orderType === IPO_ORDER_TYPE.preOrderNoPrice
  ) {
    deletePreInitialOffer(props.offer.id);
  } else {
    deleteInitialOffer(props.orderId);
  }
};
</script>
